import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChatBotWhatsappTemplateEditorComponent } from './chat-bot-whatsapp-template-editor/chat-bot-whatsapp-template-editor.component';
import { ScenarioTemplatesDependenciesComponent } from './scenario-templates-dependencies/scenario-templates-dependencies.component';
import { SelectWhatsappTemplateComponent } from './select-whatsapp-template/select-whatsapp-template.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    ChatBotWhatsappTemplateEditorComponent,
    ScenarioTemplatesDependenciesComponent,
    SelectWhatsappTemplateComponent,
  ],
  exports: [ChatBotWhatsappTemplateEditorComponent],
  entryComponents: [ChatBotWhatsappTemplateEditorComponent],
})
export class QuickRepliesWhatsappModule {}
